import React from "react";
import "./Salary.css";

const Salary = () => {

  return (
    <div className="change-plan">
      <div className="change-plan-1 nunito-bold-black-20px">Edit Profile</div>
    </div>
  );
}

export default Salary;
